module.exports = __webpack_public_path__ + "img/8th_life-skills.b02feff7.webp";